import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import vajralog from "../assets/images/vajra_logo.svg";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { sidebarElements1, sidebarElementsFacility } from "../utils/constant";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useUser } from "../context/AuthContext";
import { getRoleBasedSidebar } from "../utils/sidebarFunctions";

const MainSidebar = () => {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const [openSections, setOpenSections] = useState({});
  const [companyList, SetcompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const toggleSection = (heading) => {
    setOpenSections((prev) => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };

  const handleChange = (e) => {
    setSelectedCompany(e.target.value);
    companyList.find((company) => company._id === e.target.value);
  };

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = useMemo(() => {
    return sidebarElements?.map((item) => {
      if (item.path === "/production-revenue") {
        return {
          ...item,
          heading:
            user?.companyAdmin || user?.isSubCompanyAdmin
              ? "Production & Revenue"
              : "Production",
        };
      }
      if (item.heading === "Setup" && item.subData) {
        const newSubData = item.subData.filter(
          (sub) => sub.primary !== "Facility Master" || !user?.facility,
        );
        return { ...item, subData: newSubData };
      }
      return item;
    });
  }, [sidebarElements, user]);

  useEffect(() => {
    let updated = false;
    const newOpenSections = {};

    if (location.pathname.startsWith("/value-chain-partner/downstream")) {
      newOpenSections["Value Chain"] = true;
      updated = true;
    }

    filteredSidebar.forEach((section) => {
      if (section.collapse) {
        const isActive = section.subData?.some((sub) => {
          if (sub.path && location.pathname.startsWith(sub.path)) return true;
          if (sub.url && location.pathname.startsWith(sub.url)) return true;
          if (sub.subChildren) {
            return sub.subChildren.some(
              (child) =>
                (child.path && location.pathname.startsWith(child.path)) ||
                (child.url && location.pathname.startsWith(child.url)),
            );
          }
          return false;
        });

        if (isActive) {
          newOpenSections[section.heading] = true;
          updated = true;
        }
      }
    });

    if (updated) {
      setOpenSections((prev) => ({ ...prev, ...newOpenSections }));
    }
  }, [location.pathname, filteredSidebar]);

  const renderSidebarItems = (elements) => {
    return elements?.map((section, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          marginTop: "0.5rem",
        }}
      >
        {section.heading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // border: "1px solid red",
              margin: 0,
            }}
          >
            <div
              style={{
                width: "8px",
                height: "36px",
                backgroundColor: location.pathname.startsWith(section.path)
                  ? "#EB7E0E"
                  : "transparent",
                borderRadius: "0 4px 4px 0",
              }}
            ></div>
            <Link
              to={section.path}
              onClick={(e) => {
                if (section.collapse) {
                  e.preventDefault();
                  toggleSection(section.heading);
                }
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexGrow: 1,
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                textDecoration: "none",
                color:
                  !section?.collapse &&
                  location.pathname.startsWith(section.path)
                    ? "#FFFFFF"
                    : "#000000",
                padding: "0.4rem 0.75rem",
                borderRadius: "4px",
                margin: "0rem 0.75rem 0 0.75rem",
                backgroundColor:
                  !section?.collapse &&
                  location.pathname.startsWith(section.path)
                    ? "rgba(72, 130, 87, 1)"
                    : "transparent",
              }}
            >
              <Box
                component="img"
                src={section.icon}
                alt="icon"
                sx={{
                  width: "20px",
                  height: "20px",
                  marginRight: "8px",
                  filter:
                    !section?.collapse &&
                    location.pathname.startsWith(section.path)
                      ? "invert(1)"
                      : "invert(0)",
                }}
              />

              <span
                style={{
                  flexGrow: 1,
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {section.heading}
              </span>

              {section.collapse &&
                (openSections[section.heading] ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                ))}
            </Link>
          </div>
        )}

        {section.subData &&
          (!section.collapse || openSections[section.heading]) &&
          section.subData.map((item) => (
            <div
              key={item.path || item.url}
              style={{ display: "flex", flexDirection: "column" }}
            >
              {item.subHeading ? (
                item.subcollapse ? (
                  // If subcollapse is true, it acts as a collapsible section
                  <div
                    onClick={() => toggleSection(item.subHeading)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      // lineHeight: "24px",
                      textDecoration: "none",
                      color: "#000",
                      padding: "0.4rem 0.75rem",
                      marginLeft: "2.5rem",
                      borderRadius: "4px",
                      backgroundColor: "rgba(200, 200, 200, 0.2)", // Background for collapsible sections
                    }}
                  >
                    <div>
                      <Box
                        component="img"
                        src={item.icon}
                        alt="img"
                        sx={{
                          width: "20px",
                          height: "20px",
                          marginRight: "8px",
                          filter: location.pathname.startsWith(
                            item.path || item.url,
                          )
                            ? "invert(1)"
                            : "invert(0)",
                        }}
                      />
                      {item.subHeading}
                    </div>
                    {openSections[item.subHeading] ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </div>
                ) : (
                  // If subcollapse is false, make it a cl ickable link
                  <Link
                    to={item.path || item.url}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      padding: "0.4rem 0.75rem",
                      marginLeft: "2.5rem",
                      borderRadius: "4px",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "24px",
                      color:
                        location.pathname.startsWith(item.path || item.url) ||
                        (item.primary === "Value Chain Partners" &&
                          location.pathname.startsWith(
                            "/value-chain-partner/downstream",
                          ))
                          ? "#FFFFFF"
                          : "#000000",
                      // backgroundColor: location.pathname.startsWith(
                      //   item.path || item.url
                      // )
                      //   ? "rgba(72, 130, 87, 1)"
                      //   : "transparent",
                      backgroundColor:
                        location.pathname.startsWith(item.path || item.url) ||
                        (item.primary === "Value Chain Partners" &&
                          location.pathname.startsWith(
                            "/value-chain-partner/downstream",
                          ))
                          ? "rgba(72, 130, 87, 1)"
                          : "transparent",

                      transition: "background-color 0.3s ease, color 0.3s ease",
                    }}
                  >
                    <Box
                      component="img"
                      src={item.icon}
                      alt="img"
                      sx={{
                        width: "20px",
                        height: "20px",
                        marginRight: "8px",
                        filter:
                          location.pathname.startsWith(item.path || item.url) ||
                          (item.primary === "Value Chain Partners" &&
                            location.pathname.startsWith(
                              "/value-chain-partner/downstream",
                            ))
                            ? "invert(1)"
                            : "invert(0)",
                      }}
                    />
                    <Typography
                      style={{
                        color:
                          location.pathname.startsWith(item.path || item.url) ||
                          (item.primary === "Value Chain Partners" &&
                            location.pathname.startsWith(
                              "/value-chain-partner/downstream",
                            ))
                            ? "#FFFFFF"
                            : "#000000",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      {item.subHeading}
                    </Typography>
                  </Link>
                )
              ) : (
                <Link
                  to={item.path || item.url}
                  style={{
                    textDecoration: "none",
                    color: "#000",
                    padding: "0.4rem 0.75rem",
                    display: "flex",
                    borderRadius: "4px",
                    margin: "0rem 0.75rem 0 0.75rem",
                    width: "80%",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "24px",
                    backgroundColor: location.pathname.startsWith(
                      item.path || item.url,
                    )
                      ? "rgba(72, 130, 87, 1)"
                      : "transparent",
                  }}
                >
                  <Box
                    component="img"
                    src={item.icon}
                    alt="icon"
                    sx={{
                      width: "20px",
                      height: "20px",
                      marginRight: "8px",
                      filter: location.pathname.startsWith(
                        item.path || item.url,
                      )
                        ? "invert(1)"
                        : "invert(0)",
                    }}
                  />
                  <Typography
                    style={{
                      color: location.pathname.startsWith(item.path || item.url)
                        ? "#FFFFFF"
                        : "#000000",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "24px",
                    }}
                  >
                    {item.primary}
                  </Typography>
                </Link>
              )}

              {item.subChildren &&
                openSections[item.subHeading] &&
                item.subChildren.map((subItem) => (
                  <Link
                    key={subItem.path}
                    to={subItem.path}
                    style={{
                      textDecoration: "none",
                      color: "#000",
                      padding: "0.4rem 0.75rem",
                      display: "flex",
                      borderRadius: "4px",
                      margin: "0rem 0rem 0 2.5rem",
                      width: "80%",
                      backgroundColor: location.pathname.startsWith(
                        subItem.path,
                      )
                        ? "rgba(72, 130, 87, 1)"
                        : "transparent",
                    }}
                  >
                    <Box
                      component="img"
                      src={subItem.icon}
                      alt={"icon"}
                      sx={{
                        width: "20px",
                        height: "20px",
                        marginRight: "8px",
                        filter: location.pathname.startsWith(subItem.path)
                          ? "invert(1)"
                          : "invert(0)",
                      }}
                    />
                    <Typography
                      style={{
                        color: location.pathname.startsWith(subItem.path)
                          ? "#FFFFFF"
                          : "#000000",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      {subItem.primary}
                    </Typography>
                  </Link>
                ))}
            </div>
          ))}
      </div>
    ));
  };

  return (
    <>
      <Box display="flex" height="100vh" sx={{ width: "100%" }}>
        <Box>
          <Box display="flex" justifyContent="center" p={2}>
            <img
              src={vajralog}
              alt="Nirantara Logo"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/dashboard")}
            />
          </Box>
          <Divider />
          <div style={{ width: "20vw" }}>
            {/* <Box sx={{ padding: "20px" }}> */}
            {/* </Box> */}
            {renderSidebarItems(filteredSidebar)}
          </div>
        </Box>
      </Box>
    </>
  );
};

export default MainSidebar;
